// extracted by mini-css-extract-plugin
module.exports = {"delay-600":"animated_delay-600__KOshz","delay-800":"animated_delay-800__qgLco","slideInLeft":"animated_slideInLeft__Sb_PR","slideInDown":"animated_slideInDown__V7jDG"};